import React from 'react'
import Sidebar from '../../components/Sidebar'
import Navbar from '../../components/Navbar'
import HeartbeatFailComponent from '../../components/HeartbeatFailComponent/HeartbeatFailComponent'

const HeartbeatFail = () => {
    return (
        <div>
            <div className='flex'>
                <div className='w-[15%]'>
                    <Sidebar />
                </div>
                <div>
                    <Navbar />
                    <HeartbeatFailComponent/>
                </div>
            </div>
        </div>
    )
}

export default HeartbeatFail
